(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-default"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var defaultBreadcrumbs = document.querySelector('.breadcrumbs-default');
    if (window.location.href.includes("products/")) {
      defaultBreadcrumbs.classList.add('hidden');
    }
    var stickyBreadcrumbs = document.querySelector('.breadcrumbs-sticky');
    var stickyBreadcrumbsMobile = document.querySelector('.breadcrumbs-sticky-mobile');
    var breadcrumbElement = document.querySelector('.breadcrumb');
    var isActiveBreadcrumb = breadcrumbElement && breadcrumbElement.classList.contains('isActive');

    // Toggle breadcrumbs on scroll
    window.addEventListener('scroll', function () {
      if (window.scrollY >= 100) {
        if (stickyBreadcrumbs) stickyBreadcrumbs.style.display = 'block';
        if (stickyBreadcrumbsMobile) stickyBreadcrumbsMobile.style.display = 'block';
        if (defaultBreadcrumbs) defaultBreadcrumbs.style.display = 'none';
      } else {
        if (defaultBreadcrumbs) defaultBreadcrumbs.style.display = 'block';
        if (stickyBreadcrumbsMobile) stickyBreadcrumbsMobile.style.display = 'none';
        if (stickyBreadcrumbs) stickyBreadcrumbs.style.display = 'none';
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
